import apiClient from './apiClient';

export const getMySubscription = () =>
  apiClient.get('/api/subscriptions/me').then((res) => res.data);

export const cancelSubscription = (attempt_id) =>
  apiClient.post('/api/subscriptions/cancel', { attempt_id }).then((res) => res.data);

export const reactivateSubscription = () =>
  apiClient.post('/api/subscriptions/reactivate').then((res) => res.data);

export const createBillingPortalSession = () =>
  apiClient.post('/api/subscriptions/portal-session').then((res) => res.data);

export const submitCancellationReason = (reason, description) =>
  apiClient.post('/api/subscriptions/cancellation/reason', { reason, description }).then((res) => res.data);

export const respondToRetentionOffer = (attempt_id, response, offer) =>
  apiClient.post('/api/subscriptions/cancellation/offer-response', { attempt_id, response, offer }).then((res) => res.data);
